import {FieldContext, useField, validate} from 'vee-validate';
import {isEmpty, map} from 'lodash-es';
import {Ref} from 'vue';
import {ValidationError} from 'yup';
import * as yup from 'yup';

export async function klValidateRules(rules, newValue, params) {
    // console.log('_validateRules', rules, newValue, params)
    const result = await validate(newValue, rules, params);
    if (!isEmpty(result.errors)) {
        return result.errors[0];
    }
    return true;
}


export type ValidationBaseSchemaType = { fields: {[id: string]: any}, describe: () => any };
export type ValidationBaseFormType = { errors: {[id: string]: any }};
export type ValidationField = {
    key: string;
    label: string;
    path: string;
    field: FieldContext;
    value: any;
    getValue: <T>()=> Ref<T>;
};

export type ValidationFieldsType<SCHEMA_TYPE extends ValidationBaseSchemaType> = { [Property in keyof SCHEMA_TYPE['fields']]: ValidationField};

export function klValidationFields<SCHEMA_TYPE extends ValidationBaseSchemaType>(schema: SCHEMA_TYPE, formPath: string = undefined)
    : ValidationFieldsType<SCHEMA_TYPE>
{
    console.assert(schema.fields, 'Only use this method for complex rules, use klValidationField for single rule.');
    const result: any = {};
    Object.keys(schema.fields).forEach((currentKey) => {
        const prefix = formPath ? `${formPath}.` : '';
        const field = useField(prefix + currentKey);
        result[currentKey] = {
            key: currentKey,
            label: schema.fields[currentKey]?.describe().label,
            path: prefix + currentKey,

            field: field,
            value: field.value,
            getValue: <T>() => field.value as Ref<T>,
        }
    });

    return result;
}

// for schema describing a single field
export function klValidationField(schema: yup.Schema, formPath: string = undefined): ValidationField {
    const currentKey = formPath || '';
    const field = useField(currentKey);
    return {
        key: currentKey,
        label: schema.describe().label,
        path: currentKey,

        field: field,
        value: field.value,
        getValue: <T>() => field.value as Ref<T>,
    }
}

export async function klValidateYup(value: any, schema: yup.Schema): Promise<{ valid: boolean, errors?: string[] }> {
    if (!schema) {
        return {
            valid: true,
        }
    }

    try {
        await schema.validate(value);
        return {
            valid: true,
        }
    }
    catch (e) {
        const validationError = e as ValidationError;
        return {
            valid: false,
            errors: validationError.errors,
        }
    }
}
